import {useQueryClient} from "@tanstack/react-query";
import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {NOTIFICATION_FEED_QUERY_KEY} from "@/src/modules/notification-feed/hooks/use-notification-feed";

import {briefingBoardsService} from "../services";

export type BriefingBoardMarkReadVariables = {
  id: number;
  shift_id: number;
};

type UseBriefingBoardReadParams = {
  onSuccess?: () => void;
};

export default function useBriefingBoardRead(params?: UseBriefingBoardReadParams) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({id, shift_id}: BriefingBoardMarkReadVariables) =>
      briefingBoardsService.markBriefingBoardRead(id, shift_id),
    networkMode: "offlineFirst",
    onSuccess: () => {
      const keys = [
        "briefingboard-inbox",
        "infinite-briefingboard-inbox",
        "briefingboard-pending",
        "briefingboards",
        "infinite-briefing-boards",
        "briefingboard",
        "briefingboard-unread",
        NOTIFICATION_FEED_QUERY_KEY,
      ];

      keys.forEach((key) => {
        void queryClient.refetchQueries({queryKey: [key], type: "all"});
      });

      params?.onSuccess?.();
    },
    onError: () => {
      toast.error(
        "Couldn't confirm read. Check your connection and try again.",
        TOAST_CONFIG,
      );
    },
  });
}
